import React from 'react';
import { SettingsBreadcrumbs } from '../settingsModule';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';
import InnerBlock from '../../shared/web/layout/InnerBlock';
import { Text } from 'ui-builder';
import useCodeHandler from './codeHandler';

export default function CalendarIntegrationCallbackPage() {
  useCodeHandler();

  return (
    <>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Calendar Integration" />
      </SettingsBreadcrumbs>
      <InnerBlock title="Calendar Integration">
        <Text>Processing...</Text>
      </InnerBlock>
    </>
  );
}
